/* eslint-disable unicorn/filename-case */
import { css } from 'styled-components';
import {
  mqSmallMin,
  mqTabletMax,
  mqLargeMin,
} from 'styled/tools/media-queries';

export const defaultFont = css`
  font-family: var(--flag-font-family);
  font-style: normal;
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const Fontw35s12h20 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 12px;
  line-height: 20px;
`;

export const Fontw35s14h14 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 14px;
  line-height: 14px;
`;

export const Fontw35s16h24 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 16px;
  line-height: 24px;
`;

export const Fontw35s18h24 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 18px;
  line-height: 24px;
`;

export const Fontw35s18h28 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 18px;
  line-height: 28px;
`;

export const Fontw35s24h32 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 24px;
  line-height: 32px;
`;
export const Fontw35s26h31 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 26px;
  line-height: 31.2px;
`;

export const Fontw35s26h40 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 26px;
  line-height: 40px;
`;

export const Fontw35s32h40 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 32px;
  line-height: 40px;
`;

export const Fontw35s40h48 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 40px;
  line-height: 48px;
`;

export const Fontw35s48h56 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 48px;
  line-height: 56px;
`;

export const Fontw35s48h60 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 48px;
  line-height: 60px;
`;

export const Fontw35s56h64 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 56px;
  line-height: 64px;
`;

export const Fontw35s64h72 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 64px;
  line-height: 72px;
`;

export const Fontw35s68h80 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 68px;
  line-height: 80px;
`;

export const Fontw35s72h80 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 72px;
  line-height: 80px;
`;

export const Fontw4s10h12 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
`;

export const Fontw4s10h16 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
`;

export const Fontw4s12h12 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
`;

export const Fontw4s12h16 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

export const Fontw4s12h18 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`;

export const Fontw4s12h24 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
`;

export const Fontw4s14h16 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export const Fontw4s14h20 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const Fontw4s14h21 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`;

export const Fontw4s14h24 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
`;

export const Fontw4s16h24 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
export const Fontw4s18h20 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 18px;

  line-height: 20px;
`;
export const Fontw4s18h24 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 18px;

  line-height: 24px;
`;

export const Fontw4s18h28 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
`;

export const Fontw4s22h30 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 22px;
  line-height: 30px;
`;

export const Fontw4s24h30 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
`;

export const Fontw4s24h32 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
`;

export const Fontw35s24h36 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 24px;
  line-height: 36px;
`;

export const Fontw35s30h40 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 30px;
  line-height: 40px;
`;

export const Fontw4s30h36 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 30px;
  line-height: 36px;
`;

export const Fontw4s32h40 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 32px;
  line-height: 40px;
`;

export const Fontw4s36h48 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 36px;
  line-height: 48px;
`;

export const Fontw4s40h44 = css`
  ${defaultFont}
  font-weight: 400;
  font-size: 40px;
  line-height: 44px;
`;

export const Fontw5s12h18 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
`;

export const Fontw5s12h20 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
`;

export const Fontw5s12h24 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
`;

export const Fontw5s14h20 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

export const Fontw5s14h24 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`;

export const Fontw5s14h40 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 14px;
  line-height: 40px;
`;

export const Fontw5s16h18 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
`;

export const Fontw5s16h20 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`;

export const Fontw5s16h24 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;

export const Fontw5s16h28 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
`;

export const Fontw5s18h24 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;

export const Fontw5s18h28 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
`;

export const Fontw5s24h32 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
`;

export const Fontw5s32h45 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 32px;
  line-height: 45px;
`;

export const Fontw5s12h12 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
`;

export const Fontw5s12h16 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`;

export const Fontw5s14h12 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 14px;
  line-height: 12px;
`;

export const Fontw5s14h16 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const Fontw5s14h18 = css`
  ${defaultFont}
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
`;

export const Fontw35s80h80 = css`
  ${defaultFont}
  font-weight: 350;
  font-size: 80px;
  line-height: 80px;
`;

export const Fontw7s14h20 = css`
  ${defaultFont}
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`;

export const DynamicFont = css`
  ${defaultFont}
`;

// Everything below is for helping convert our SCSS to styled-components

const layoutWidth = '1440px';
const layoutPaddingLg = '50px';
// const layoutPaddingLgX2 = '100px';
const layoutPaddingSm = '30px';
// const layoutPaddingSmX2 = '60px';

export const WithSiteLayoutWidth = css`
  max-width: ${layoutWidth};
  width: 100%;
`;

export const WithSiteLayoutPadding = css`
  padding-left: ${layoutPaddingSm};
  padding-right: ${layoutPaddingSm};

  @media ${mqLargeMin} {
    padding-left: ${layoutPaddingLg};
    padding-right: ${layoutPaddingLg};
  }
`;

export const Centered = css`
  margin-left: auto;
  margin-right: auto;
`;

export const WithSiteLayout = css`
  ${WithSiteLayoutWidth}
  ${WithSiteLayoutPadding}
  ${Centered}
`;

export const WithFontHead = css`
  font-style: normal;
  font-weight: 300;
  font-family: var(--flag-font-family);
  letter-spacing: normal;
  line-height: 1.1;
`;

export const WithFontHeadline = css`
  ${WithFontHead}
  color: var(--text-primary);
  font-size: 70px;
  @media ${mqTabletMax} {
    font-size: 45px;
  }
`;

export const WithFontBody = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  font-family: var(--flag-font-family);
  letter-spacing: normal;
  line-height: 1.5;
`;

export const AspectRatio = (ratioString) => {
  let paddingBottom;

  switch (ratioString) {
    case '16x9':
      paddingBottom = '56.25%';
      break;
    case '9x16':
      paddingBottom = '177.77%';
      break;
    case '4x3':
      paddingBottom = '75%';
      break;
    case '3x4':
      paddingBottom = '133.33%';
      break;
    case '6x4':
      paddingBottom = '66.6%';
      break;
    case '4x6':
      paddingBottom = '150%';
      break;
    case '8x5':
      paddingBottom = '62.5%';
      break;
    case '5x8':
      paddingBottom = '160%';
      break;
    case '7x5':
      paddingBottom = '71.42%';
      break;
    case '5x7':
      paddingBottom = '140%';
      break;
    case '1x1':
      paddingBottom = '100%';
      break;
    default:
      paddingBottom = '100%'; // Default to 1x1 if no match
  }

  return css`
    height: 0;
    position: relative;
    padding-bottom: ${paddingBottom};
  `;
};

export const AspectRatioObject = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
`;

export const Clearfix = css`
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  *zoom: 1;
`;

export const Separator = css`
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25) inset;
  background: #fff;
  display: block;
  width: 100%;
  height: 15px;
`;

export const GradientHorizontal = (
  colorOne,
  colorTwo,
  percentageOne = 0,
  percentageTwo = 100,
) => css`
  background-image: linear-gradient(
    to right,
    ${colorOne} ${percentageOne}%,
    ${colorTwo} ${percentageTwo}%
  );
  background-repeat: repeat-x;
`;

export const GradientVertical = (
  colorOne,
  colorTwo,
  percentageOne = 0,
  percentageTwo = 100,
) => css`
  background-image: linear-gradient(
    to bottom,
    ${colorOne} ${percentageOne}%,
    ${colorTwo} ${percentageTwo}%
  );
  background-repeat: repeat-x;
`;

export const GradientDiagonal = (
  colorOne,
  colorTwo,
  percentageOne = 0,
  percentageTwo = 100,
) => css`
  background-image: linear-gradient(
    to bottom right,
    ${colorOne} ${percentageOne}%,
    ${colorTwo} ${percentageTwo}%
  );
`;

export const ImgShadow = css`
  filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3));
`;

export const Ellipsis = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HideScrollbar = css`
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    display: none;
    background: transparent;
  }
`;

export const SiteButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  font-weight: 500;
  font-family: var(--flag-font-family);
  letter-spacing: normal;
  line-height: 1;
  font-size: 14px;
  text-align: center;
  border-width: 1px;
  border-style: solid;
  padding: 0 1rem;
  margin: 0;
  height: 50px;
  cursor: pointer;
  color: #fff;
  background-color: var(--fill-brand);
  border-radius: 99px;
  border-color: var(--outline-primary);
  letter-spacing: 0.5px;
  text-decoration: none;
  min-width: 180px;
  margin-top: 20px;
  width: 100%;
  @media ${mqSmallMin} {
    margin-top: 0;
    width: auto;
  }
`;

export const SiteButton2 = css`
  ${SiteButton}
  color: #fff;
  background-color: #54bafe;
  border-color: #54bafe;
`;

export const SiteButtonHover = css`
  color: #fff;
  background-color: #162e0f;
  border-color: #162e0f;
  outline: solid 2px #162e0f;
  outline-offset: 5px;
`;

export const SiteButtonHover2 = css`
  color: #fff;
  background-color: #016095;
  border-color: #016095;
`;

export const WithSiteBleedScreen = css`
  width: 100%;
  @media ${mqLargeMin} {
    width: calc() (100% + ((100vw - 100%) / 2));
  }
`;

export const WithSiteBleedLayout = (widthInt) => {
  const width = widthInt + (1440 - widthInt - 100) / 2;

  return css`
    width: 100%;
    @media ${mqLargeMin} {
      width: ${width}px;
    }
  `;
};
